<script>
export default {
  name: 'MainFilterSelect',
  props: {
    availableItems: {
      type: Array,
      required: true,
    },
    selectedItems: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    updateItems: {
      type: Function,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
    <v-container ma-0 pa-0>
        <v-autocomplete
          @change="updateItems"
          :value="selectedItems"
          :items="availableItems"
          :label="label"
          :disabled="disabled"
          item-text="name"
          item-value="id"
          clearable
          multiple
        >
            <template slot="selection" slot-scope="{ item, index }">
                <v-chip small v-if="index === 0">
                    <span v-if="item.name.length > 20">{{ item.name.substring(0, 20) }}...</span>
                    <span v-else>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text caption">
                    (
                        +{{ selectedItems.length - 1 }}
                        {{ $tc('inputs.others', selectedItems.length - 1) }}
                    )
                </span>
            </template>
        </v-autocomplete>
    </v-container>
</template>



// WEBPACK FOOTER //
// src/components/payments/supplier-payments/SupplierPaymentsSupplierFilterSelect.vue